import { SSCompanyLayout } from '@/src/layout/superstack/SSLayout';
import { SSHeaderLandingCompany } from '@/src/layout/superstack/SSHeader';
import LinkTag from '@/src/component/LinkTag';
import { GeneralLinks } from '@/data/superstack/GeneralLinks';
import { CompanyGeneralLinks } from '@/data/superstack/companies/CompanyGeneralLinks';
import SSImage from '@/src/component/superstack/base/SSImage';
import { Button } from '@/src/component/superstack/base/Button';
import ImgLandingCompanyStacks from '@/asset/superstack/pngs/img-landing-company-stacks.png';
import ImgLandingCompanyCulture from '@/asset/superstack/pngs/img-landing-company-culture.png';
import ImgLandingCompanyProfile1 from '@/asset/superstack/pngs/img-landing-company-profile-1.png';
import ImgLandingCompanyProfile2 from '@/asset/superstack/pngs/img-landing-company-profile-2.png';
import ImgLandingCompanyProfile3 from '@/asset/superstack/pngs/img-landing-company-profile-3.png';
import ImgLandingCompanyProfile4 from '@/asset/superstack/pngs/img-landing-company-profile-4.png';
import IconLandingCompanyStack from '@/asset/superstack/pngs/icon-landing-company-stack.png';
import IconLandingCompanyTeam from '@/asset/superstack/pngs/icon-landing-company-team.png';
import IconLandingCompanyCulture from '@/asset/superstack/pngs/icon-landing-company-culture.png';
import IconLandingCompanyCareer from '@/asset/superstack/pngs/icon-landing-company-career.png';
import IconLandingCompanyCertificated from '@/asset/superstack/pngs/icon-landing-company-certificated.png';
import IconLandingCompanyCode from '@/asset/superstack/pngs/icon-landing-company-code.png';
import styles from '@/styles/superstack/companies/landing.module.scss';
import classNames from 'classnames/bind';

const JOBS_INTRO_FILE_ID = 7;

const CompanyLandingWrapper = () => {
  const cx = classNames.bind(styles);
  const companyIntroDownloadUrl =
    GeneralLinks().find((link) => link.name === '관리 파일 다운로드')?.url +
    `${JOBS_INTRO_FILE_ID}/download/`;
  const DefaultBanner = () => {
    return (
      <div className={cx('container')}>
        <div className={cx('content-wrapper')}>
          <h7 className={cx('service-name')}>Wishket Jobs</h7>
          <div>
            <h4 className={cx(['title', 'pc'])}>좋은 개발자를 찾는 방법, 위시켓 잡스</h4>
            <h7 className={cx(['subtitle', 'pc'])} style={{ display: 'block', marginTop: '8px' }}>
              회사의 기술 스택과 딱 맞는 개발자, 위시켓 잡스에서 찾아드려요.
            </h7>
          </div>
          <h4 className={cx(['title', 'mobile'])}>
            좋은 개발자를
            <br />
            찾는 방법,
            <br />
            위시켓 잡스
          </h4>
          <div className={cx('btn-wrapper')}>
            <LinkTag
              href={CompanyGeneralLinks().find((link) => link.name === 'create_new_company')?.url}
              isNextPage={true}
            >
              <button type={'button'} className={cx(['btn', 'blue'])}>
                지금 시작하기
              </button>
            </LinkTag>
          </div>
        </div>
      </div>
    );
  };
  return (
    <SSCompanyLayout
      pageTitle={'기업회원 시작하기 | 위시켓 잡스'}
      width={'100%'}
      Header={SSHeaderLandingCompany}
    >
      <section className={cx('intro')}>
        <DefaultBanner />
      </section>
      <section className={cx('plain')}>
        <div className={cx('container')}>
          <h5 className={cx('pc')}>
            이력서 검토와 면접의 반복.
            <br />
            기술과 조직 문화에 딱 맞는 개발자를 만나려면,
            <br />
            많은 시간과 노력이 필요했습니다.
            <br />
            <br />
            이제, 위시켓 잡스에서 좋은 개발자를 쉽고 편하게 찾아보세요.
          </h5>
          <h7 className={cx('mobile')}>
            이력서 검토와 면접의 반복.
            <br />
            <br />
            기술과 조직 문화에 <br />딱 맞는 개발자를 만나려면,
            <br />
            많은 시간과 노력이 필요했습니다.
            <br />
            <br />
            이제, 위시켓 잡스에서
            <br />
            좋은 개발자를 쉽고 편하게 찾아보세요.
          </h7>
        </div>
      </section>
      <section className={cx('features')}>
        <div
          className={cx('container')}
          style={{ display: 'flex', flexDirection: 'column', gap: '80px' }}
        >
          <div className={cx('element')}>
            <div className={cx('content')}>
              <h7 className={cx(['title', 'pc'])}>기술 스택</h7>
              <h4 className={cx('subtitle')}>
                개발자의 경력에서 추출한
                <br />
                기술 스택
              </h4>
              <p className={cx('text')}>
                개발자의 경력에서 기술 스택을 추출하여
                <br />
                실제 업무에서 사용한 기술과
                <br />그 기술을 얼마나 사용해왔는지 알 수 있어요.
              </p>
            </div>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyStacks} />
            </div>
            <div className={cx(['mobile-title-wrapper', 'mobile'])}>
              <h7 className={cx('title')}>기술 스택</h7>
            </div>
          </div>
          <div className={cx('element')}>
            <div className={cx('content')}>
              <h7 className={cx(['title', 'pc'])}>컬처코드</h7>
              <h4 className={cx('subtitle')}>
                우리와 잘 맞는 개발자인지
                <br />
                쉽게 알아보는 방법
              </h4>
              <p className={cx('text')}>
                조직 문화를 잘 나타내는 질문/답변을 통해
                <br />
                개발자와 우리 조직이 얼마나 잘 맞을지
                <br />
                미리 확인할 수 있어요.
              </p>
            </div>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyCulture} />
            </div>
            <div className={cx(['mobile-title-wrapper', 'mobile'])}>
              <h7 className={cx('title')}>컬처코드</h7>
            </div>
          </div>
        </div>
      </section>
      <section className={cx('zigzag')}>
        <div
          className={cx(['container', 'pc'])}
          style={{ display: 'flex', flexDirection: 'column', gap: '120px' }}
        >
          <article className={cx('element-zigzag')}>
            <div className={cx('content')}>
              <h4 className={cx('subtitle')}>
                개발자 채용을 위한
                <br />
                최적의 채용 공고
              </h4>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyStack} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>구체적인 기술과 기술 경력</p>
                    <p className={cx('text')}>
                      원하는 기술을 가진 개발자는 물론, 기술 숙련도가 높은
                      <br />
                      개발자를 채용할 수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyTeam} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>개발자가 궁금해하던 프로덕트/팀 소개 </p>
                    <p className={cx('text')}>
                      개발자에게 우리 프로덕트의 기술 스택과 조직 구성원을
                      <br />
                      쉽게 소개할 수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage
                    layout={'fixed'}
                    width={40}
                    height={40}
                    src={IconLandingCompanyCulture}
                  />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>사전에 맞춰보는 조직 문화 적합도</p>
                    <p className={cx('text')}>
                      직접 만나봐야만 알 수 있었던 조직 문화 적합도,
                      <br />
                      이젠 면접 전에 개발자와 미리 맞춰볼 수 있어요.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile1} />
              <SSImage src={ImgLandingCompanyProfile2} />
            </div>
          </article>
          <article className={cx('element-zigzag')}>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile3} />
              <SSImage src={ImgLandingCompanyProfile4} />
            </div>
            <div className={cx('content')}>
              <h4 className={cx('subtitle')}>
                이력서를 넘어선
                <br />
                위시켓 잡스 개발자 프로필
              </h4>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyCareer} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>구체적인 경력 정보</p>
                    <p className={cx('text')}>
                      근무했던 경력뿐만 아니라 업무 수준, 담당 역할,
                      <br />
                      사용했던 기술까지 구체적으로 알 수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyCode} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>개발자가 실제로 보유한 기술 스택</p>
                    <p className={cx('text')}>
                      개발자가 우리 회사에 필요한 기술을 가졌는지
                      <br />
                      쉽게 확인할 수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage
                    layout={'fixed'}
                    width={40}
                    height={40}
                    src={IconLandingCompanyCertificated}
                  />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>다른 이력서에서 볼 수 없던 개발 전문성까지</p>
                    <p className={cx('text')}>
                      국내 1위 IT 아웃소싱 플랫폼 위시켓에서 진행한
                      <br />
                      프로젝트 이력을 통해, 또 다른 개발 전문성까지
                      <br />
                      확인할 수 있어요. (22년 5월 시밀러웹 방문자수 기준)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </article>
        </div>
        <div
          className={cx(['container', 'mobile'])}
          style={{ display: 'flex', flexDirection: 'column', gap: '100px' }}
        >
          <article className={cx('element-zigzag')}>
            <h5 className={cx('subtitle')}>
              개발자 채용을 위한
              <br />
              최적의 채용 공고
            </h5>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile1} />
            </div>
            <div className={cx('content')}>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyStack} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>구체적인 기술과 기술 경력</p>
                    <p className={cx('text')}>
                      원하는 기술을 가진 개발자는 물론, 기술 숙련도가 높은 개발자를 채용할 수
                      있어요.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile2} />
            </div>
            <div className={cx('content')}>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyTeam} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>
                      개발자가 궁금해하던
                      <br />
                      프로덕트/팀 소개
                    </p>
                    <p className={cx('text')}>
                      개발자에게 우리 프로덕트의 기술 스택과 조직 구성원을 쉽게 소개할 수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage
                    layout={'fixed'}
                    width={40}
                    height={40}
                    src={IconLandingCompanyCulture}
                  />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>
                      사전에 맞춰보는 조직 문화
                      <br />
                      적합도
                    </p>
                    <p className={cx('text')}>
                      직접 만나봐야만 알 수 있었던 조직 문화 적합도, 이젠 면접 전에 개발자와 미리
                      맞춰볼 수 있어요.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </article>
          <article className={cx('element-zigzag')}>
            <h5 className={cx('subtitle')}>
              이력서를 넘어선
              <br />
              위시켓 잡스 개발자 프로필
            </h5>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile3} />
            </div>
            <div className={cx('content')}>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyCareer} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>구체적인 경력 정보</p>
                    <p className={cx('text')}>
                      근무했던 경력뿐만 아니라 업무 수준, 담당 역할, 사용했던 기술까지 구체적으로 알
                      수 있어요.
                    </p>
                  </div>
                </li>
                <li className={cx('li')}>
                  <SSImage layout={'fixed'} width={40} height={40} src={IconLandingCompanyCode} />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>
                      개발자가 실제로 보유한 <br />
                      기술 스택
                    </p>
                    <p className={cx('text')}>
                      개발자가 우리 회사에 필요한 기술을 가졌는지 쉽게 확인할 수 있어요.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className={cx('img-box')}>
              <SSImage src={ImgLandingCompanyProfile4} />
            </div>
            <div className={cx('content')}>
              <ul className={cx('ul')}>
                <li className={cx('li')}>
                  <SSImage
                    layout={'fixed'}
                    width={40}
                    height={40}
                    src={IconLandingCompanyCertificated}
                  />
                  <div className={cx('text-wrapper')}>
                    <p className={cx('title')}>다른 이력서에서 볼 수 없던 개발 전문성까지</p>
                    <p className={cx('text')}>
                      국내 1위 IT 아웃소싱 플랫폼 위시켓에서 진행한 프로젝트 이력을 통해, 또 다른
                      개발 전문성까지 확인할 수 있어요. (22년 5월 시밀러웹 방문자수 기준)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </article>
        </div>
      </section>
      <section className={cx('cta')}>
        <h4 className={cx(['title', 'pc'])}>위시켓 잡스에서 우리와 딱 맞는 개발자를 채용하세요.</h4>
        <h6 className={cx(['title', 'mobile'])}>
          위시켓 잡스에서
          <br />
          우리와 딱 맞는 개발자를
          <br />
          채용하세요.
        </h6>

        <div className={cx('btn-wrapper')}>
          <LinkTag
            href={CompanyGeneralLinks().find((link) => link.name === 'create_new_company')?.url}
            isNextPage={true}
          >
            <Button mode={'filled'} size={'xl'}>
              기업 서비스 시작하기
            </Button>
          </LinkTag>
          <LinkTag href={companyIntroDownloadUrl}>
            <Button mode={'stroke'} size={'xl'}>
              회사 소개서
            </Button>
          </LinkTag>
        </div>
      </section>
    </SSCompanyLayout>
  );
};

export default CompanyLandingWrapper;
